import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import config from 'config';
import { DocumentTitle } from 'shared/components';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { AppointmentsFetchPendingPlaceholder } from 'modules/queues/common/components';
import { getCurrentLanguage } from 'modules/language/selectors/language';
import { primaryLight, primaryMedium } from 'styleVars/getColors';

import theme from './CreateAppointmentPage.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  sessionRequestStatus: PropTypes.string,
  sessionInitialized: PropTypes.bool,
  screenHeight: PropTypes.any,
  isExternalInit: PropTypes.bool,
};

const defaultProps = {
  sessionRequestStatus: null,
  sessionInitialized: false,
  screenHeight: null,
  isExternalInit: false,
};

const CreateAppointmentPage = ({
  intl,
  sessionInitialized,
  sessionRequestStatus,
  screenHeight,
  isExternalInit,
}) => {
  return (
    <div className={ theme.root } style={{ height: screenHeight }}>
      <Choose>
        <When condition={ !sessionInitialized && (!sessionRequestStatus || sessionRequestStatus === requestsStatuses.pending) }>
          <AppointmentsFetchPendingPlaceholder />
        </When>
        <Otherwise>
          <iframe
            style={{ height: '100%', width: '100%', outline: 'none', border: 'none' }}
            title="ppac"
            src={ `${ config.web_cac_link }/${ getCurrentLanguage() }/appointment/create?token=${ localStorage.getItem('jwt') }&type=CLIENT&theme=${ primaryMedium.replace('#', '') },${ primaryLight.replace('#', '') }&isExternalInit=${ isExternalInit }` } //eslint-disable-line
          />
        </Otherwise>
      </Choose>
      <DocumentTitle title={ intl.formatMessage({ id: 'Patient.Appointment.Create.NewAppointment.Header', defaultMessage: '** New Appointment' }) } />
    </div>
  );
};

CreateAppointmentPage.propTypes = propTypes;
CreateAppointmentPage.defaultProps = defaultProps;

export default injectIntl(CreateAppointmentPage);
